import React, { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import {
  Typography,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Card,
  CardContent,
  Theme,
  TableFooter,
  IconButton,
} from '@mui/material';
import { makeStyles, createStyles } from '@mui/styles';
import { Row, Col } from 'react-bootstrap';
import LinkOffIcon from '@mui/icons-material/LinkOff';
import LinkIcon from '@mui/icons-material/Link';

import { SHeadTableCell } from '../../../../../components/styledComponents/Tables';
import Preloader from '../../../../../components/other/Preloader/Preloader';
import homeStyles from '../../../../../constants/homeStyles';
import TablePaginator from '../../../../../components/tableComponents/TablePaginator/TablePaginator';
import { useGetManufacturer } from '../../hooks/useGetManufacturer';
import { Manufacturer } from '../../../../../interfaces/manufacturer';
import { ManufacturersSearchField } from '../ManufacturersSearchField';

export const ManufacturersTable = ({
  onConnect,
  show,
  currentValue,
}: {
  onConnect: (value: Manufacturer) => void;
  show: boolean;
  currentValue?: Manufacturer | null;
}) => {
  const { fetch, loading, page, manufacturers } = useGetManufacturer();
  const [search, setSearch] = useState('');

  const homeClasses = homeStyles();
  const classes = useStyles();
  const intl = useIntl();

  useEffect(() => {
    show && fetch({ page: 1, per_page: 20 });
  }, [show]);

  const handleSearch = (value?: string) => {
    setSearch(value || '');
    if (value !== search) {
      fetch({ page: 1, per_page: 20, text: value });
    }
  };

  if (loading) return <Preloader />;

  return (
    <>
      <Row>
        <Col>
          <ManufacturersSearchField handleSearch={handleSearch} search={search} />
          {!manufacturers || !manufacturers.length ? (
            <Typography className={classes.empty} component='h5' variant='h5'>
              {intl.formatMessage({ id: 'COMMON.LIST.EMPTY' })}
            </Typography>
          ) : (
            <>
              <Card className={classes.card}>
                <CardContent className={homeClasses.classes.tableContainer}>
                  <Table aria-label='simple table'>
                    <TableHead>
                      <TableRow>
                        <SHeadTableCell className={classes.rowItems}>
                          {intl.formatMessage({ id: 'PRODUCT.TABLE.ID' })}
                        </SHeadTableCell>
                        <SHeadTableCell className={classes.rowItems}>
                          Уникальное наименование
                        </SHeadTableCell>
                        <SHeadTableCell className={classes.rowItems}>
                          Отображаемое наименование
                        </SHeadTableCell>
                        <SHeadTableCell className={classes.rowItems}>
                          Английское наименование
                        </SHeadTableCell>
                        <SHeadTableCell align='right' className={classes.rowItems}>
                          {intl.formatMessage({ id: 'PRODUCT.TABLE.ACTIONS' })}
                        </SHeadTableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {manufacturers.map(item => (
                        <TableRow key={item.id}>
                          <TableCell component='th' scope='row' className={classes.rowItems}>
                            {item.id || '-'}
                          </TableCell>
                          <TableCell className={classes.rowItems}>
                            {item.name || '-'}
                          </TableCell>
                          <TableCell className={classes.rowItems}>
                            {item.print_name || '-'}
                          </TableCell>
                          <TableCell className={classes.rowItems}>
                            {item.english_name || '-'}
                          </TableCell>
                          <TableCell align='right'>
                            {onConnect && (
                              <IconButton onClick={() => onConnect(item)}>
                                {item.id === currentValue?.id ? (
                                  <LinkOffIcon color='error' />
                                ) : (
                                  <LinkIcon color='primary' />
                                )}
                              </IconButton>
                            )}
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                    <TableFooter>
                      <TableRow>
                        <TablePaginator
                          page={page.page}
                          perPage={page.perPage}
                          total={page.total}
                          fetchRows={(data: any) =>
                            fetch({ page: data.page, per_page: data.perPage, text: search })
                          }
                          label='Производителей на странице'
                        />
                      </TableRow>
                    </TableFooter>
                  </Table>
                </CardContent>
              </Card>
            </>
          )}
        </Col>
      </Row>
    </>
  );
};

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    empty: {
      marginBottom: 20,
      marginTop: 20,
    },
    buttons: {
      marginRight: theme.spacing(3),
    },
    card: {
      marginTop: theme.spacing(3),
      marginBottom: theme.spacing(3),
    },
    categoryTree: {
      maxWidth: 400,
    },
    actions: {
      display: 'flex',
      justifyContent: 'flex-end',
    },
    img: {
      width: 50,
      height: 50,
    },
    rowItems: {
      fontSize: '17px !important',
    },
  })
);
